import * as React from 'react'
import { TextFieldProps } from 'cs-kevlar-react/lib/es/TextField'
import { UserCapabilities } from '../../api'
import { getCapabilityLabel } from 'utils'
import { TextFieldWithFullscreen } from '..'

type CapabilitiesProps = TextFieldProps & {
  capabilities: UserCapabilities[] | null
}

const inputProps = {
  readOnly: true,
}

export const Capabilities: React.FunctionComponent<CapabilitiesProps> = ({
  capabilities,
  ...rest
}) => {
  const safeCapabilities = capabilities ? capabilities : []
  const capabilityString = safeCapabilities.map(getCapabilityLabel).join(', ')

  return (
    <TextFieldWithFullscreen
      value={capabilityString}
      label="Capabilities"
      isCommaDelimited
      multiline
      fullWidth
      inputProps={inputProps}
      {...rest}
    />
  )
}
